module.exports = __webpack_public_path__ + "img/x.9c529b71.svg";